import {RateOptionApiModel} from "./rate-option.api-model";
import {OddsRateModel} from "../../odds-rate/models/odds-rate.model";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {TREND} from "../../../../../core/app/consts";
import {ExtraLinkDomainModel} from "../../extra-link/models/extra-link.domain-model";
import {makeObservable, observable} from 'mobx';

export class RateOptionDomainModel extends BaseDomainModel {
  apiModel: RateOptionApiModel;
  extraLinks: Array<ExtraLinkDomainModel>
  @observable rate: OddsRateModel;
  @observable oldRate: OddsRateModel;
  @observable preMatchRate: OddsRateModel;
  @observable originalRate: OddsRateModel;
  num: Number;
  name: String;
  link: String;
  @observable isWon: Boolean;
  @observable trend: TREND;

  constructor(apiModel: RateOptionApiModel) {
    super(apiModel);

    this.trend = apiModel.trend;
    this.name = apiModel.name;
    this.isWon = apiModel.isWon;
    this.link = apiModel.link;
    this.num = apiModel.num;
    this.rate = apiModel.rate && new OddsRateModel(apiModel.rate);
    this.oldRate = apiModel.oldRate && new OddsRateModel(apiModel.oldRate);
    this.preMatchRate = apiModel.prematchRate && new OddsRateModel(apiModel.prematchRate);
    this.originalRate = apiModel.originalRate && new OddsRateModel(apiModel.originalRate);
    this.extraLinks = apiModel.extraLinks?.map(extraLink => new ExtraLinkDomainModel(extraLink));

    makeObservable(this);
  }
}
